import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { FileHandlerService } from 'src/app/utility/services/file-handler/file-handler.service';

@Component({
  selector: 'app-file-modal',
  templateUrl: './file-modal.component.html',
  styleUrls: ['./file-modal.component.css'],
})
export class FileModalComponent implements OnInit {
  public uploader: FileUploader;
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;
  public uploadMessage = 'Upload in progress ... ';
  public errorMessage = '';
  public title = '';
  public status = false;
  public response: any;

  constructor(
    public dialogRef: MatDialogRef<FileModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fileHandlerService: FileHandlerService
  ) {
    this.uploader = data.uploader;
    this.title = data.title;
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  ngOnInit() {
    this.uploader.uploadAll();
    this.uploader.onCompleteAll = () => {};
    this.uploader.onSuccessItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ): any => {
      if (response) {
        const responseObj = JSON.parse(response);
        this.status = responseObj.status;
        this.errorMessage = responseObj.message;
        this.uploadMessage = 'Upload completed.';
        this.response = responseObj;
        // if (responseObj.file) {
        //   const binary = atob(responseObj.file);
        //   const array = new Uint8Array(binary.length);
        //   for (let i = 0; i < binary.length; i++) {
        //     array[i] = binary.charCodeAt(i);
        //   }
        //   this.fileHandlerService.downloadExcel(
        //     array,
        //     responseObj.filename + '.xlsx'
        //   );
        // }
      }
    };
    this.uploader.onErrorItem = (
      item: FileItem,
      response: string,
      status: number,
      headers: any
    ): any => {
      if (response) {
        const responseObj = JSON.parse(response);
        this.uploadMessage = 'Upload failed.';
        this.errorMessage = responseObj.message;
        item.progress = 100;
      }
    };
  }

  close() {
    this.dialogRef.close({ upload: this.status, response: this.response });
    this.uploader.clearQueue();
  }
}
